import text from './custom/text';
import forms from './custom/forms';
import badges from './custom/badges';
import { colors, font, shadows } from '../tokens';
import * as sizing from '../tokens/sizing';
import { links } from './custom/links';
import { buttons } from './custom/button';
import { body } from './custom/body';
import { Theme } from 'theme-ui';
import { markdownStyles } from './markdown';
import { select } from './custom/select';

const makeTheme = <T extends Theme>(t: T) => t;

const theme = makeTheme({
    breakpoints: ['432px', '600px', '959px'],
    space: sizing.spacing,
    colors: {
        text: colors.base.black80 as 'black80',
        background: colors.base.white as 'white',
        primary: colors.base.carrotOrange as 'carrotOrange',
        ...colors.base,
    } as const,
    fonts: {
        body: font.family.gotham as 'gotham',
        heading: font.family.publicoHeadline as 'publicoHeadline',
        ...font.family,
    } as const,
    fontSizes: sizing.font,
    fontWeights: {
        body: font.weight.normal as unknown as 'normal',
        heading: font.weight.bold as unknown as 'bold',
        ...font.weight,
    } as const,
    lineHeights: {
        body: '150%',
        heading: '1.3',
    } as const,
    shadows,
    text,
    styles: markdownStyles,
    forms,
    links,
    badges,
    buttons,
    body,
    select,
});
export type CarrotTheme = typeof theme;
export default theme;
